import http from "../../services/http";
import { handleErrors } from "../../helpers/error";
import {
  decrementCartItem,
  getCartItems,
  getCoinRate,
  incrementCartItem,
  insertBackCartItem,
  removeCartItems,
  setLatestAndroid,
  setPromotion,
  setEligibilityPromotion,
  getOrderType,
} from "../ui/cart";
import storage from "../../services/storage";
import { setLoading } from "../ui/loading";

const path = "v1/cart";
const path2 = "v1/cart/increasequantity/";
const path3 = "v1/cart/decreasequantity/";
const coin = "v1/cart/convertionrate";
const placeorder = "v1/checkout/placeorder";
const promotion = "v1/admin/promotions/active-promotion";
const eligibilitypromotion = "v1/admin/promotions/active-promotion-web";
const android = "v1/android/version";
const addticket = "v1/ticket/jk-tickets";
const swap = "v1/ticket/swap-products";

export const AddPlaceOrderToCart = ({
  body = {},
  onSuccess,
  onError,
  onEnd,
}) => {
  return async (dispatch) => {
    try {
      const res = await http.post({
        url: placeorder,
        body,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          'x-store-id': (storage.get("xStoreId") || null),
        },
      });
      onSuccess(res);

      if (res.data.success === true) {
        dispatch(getCartItems(res.data.data));
      }
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
export const AddProductToCart = ({ body = {}, onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.post({
        url: path,
        body,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          'x-store-id': (storage.get("xStoreId") || null),
        },
      });
      onSuccess(res);

      if (res.data.success === true) {
        dispatch(getCartItems(res.data.data));
      }
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
export const getProductToCart = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.get({
        url: path,
        headers: { "x-auth-token": storage.get("xAuthToken"), 'x-store-id': (storage.get("xStoreId") || null), },
      });
      onSuccess(res);
      if (res.data.success === true) {
        dispatch(getCartItems(res.data.data));
        dispatch(getOrderType(res.data));
      }
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
export const deleteProductToCart = ({
  item,
  index,
  onSuccess,
  onError,
  onEnd,
  coupon,
}) => {
  return async (dispatch) => {
    try {
      const id = item?.itemId?._id;
      dispatch(setLoading(true));

      dispatch(removeCartItems(id));

      const res = await http.delete({
        url: "v1/cart/" + id + `?coupon=${coupon}`,
        headers: { "x-auth-token": storage.get("xAuthToken"), 'x-store-id': (storage.get("xStoreId") || null), },
      });
      onSuccess(res);
      dispatch(setLoading(false));

      if (res.data.success === true) {
        // dispatch(removeCartItems(id));
      } else dispatch(insertBackCartItem({ index, item }));
    } catch (error) {
      dispatch(setLoading(false));

      dispatch(insertBackCartItem({ index, item }));
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
export const incrementSubProduct = ({
  id = "",
  body,
  onSuccess,
  onError,
  onEnd,
}) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      dispatch(incrementCartItem(id));
      const res = await http.put({
        url: path2 + id,
        body,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          'x-store-id': (storage.get("xStoreId") || null),
        },
      });
      onSuccess(res);
      dispatch(setLoading(false));

      if (res.data.success === true) {
      } else {
        dispatch(decrementCartItem(id));
      }
    } catch (error) {
      dispatch(setLoading(false));

      dispatch(decrementCartItem(id));
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
export const decrementSubProduct = ({
  id = "",
  body,
  onSuccess,
  onError,
  onEnd,
}) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));

      dispatch(decrementCartItem(id));

      const res = await http.put({
        url: path3 + id,
        body,

        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          'x-store-id': (storage.get("xStoreId") || null),
        },
      });
      onSuccess(res);
      dispatch(setLoading(false));

      if (res.data.success === true) {
      } else {
        dispatch(incrementCartItem(id));
      }
    } catch (error) {
      dispatch(incrementCartItem(id));
      dispatch(setLoading(false));

      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
export const getCoin = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.get({
        url: coin,
      });
      onSuccess(res);
      if (res.data.success === true) {
        storage.store("transactionLimit", res.data.transactionLimit);
        // console.log('transactionLimit', res.data.transactionLimit)
        dispatch(getCoinRate(res.data.data));
      }
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export const getPromotion = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.get({
        url: promotion,
      });
      onSuccess(res);
      if (res.data.success === true) {
        // console.log('getPromotion res', res.data.promotion)
        dispatch(setPromotion(res.data.promotion));
      }
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export const getEligibilityPromotion = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.get({
        url: eligibilitypromotion,
        headers: { "x-auth-token": storage.get("xAuthToken") },
      });
      onSuccess(res);
      if (res.data.success === true) {
        // console.log('getPromotion res', res.data.promotion)
        dispatch(setEligibilityPromotion(res.data.promotion));
      }
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export const getAndroidVersion = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.get({
        url: android,
      });
      onSuccess(res);
      if (res.data.success === true) {
        // console.log('getPromotion res', res.data.promotion)
        dispatch(setLatestAndroid(res.data?.downloadLink));
      }
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export const getCoupon = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.get({
        url: "v1/checkout/coupons",
        headers: { "x-auth-token": storage.get("xAuthToken") },
      });
      onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
export const applyCoupon = ({ coupon, onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.get({
        url: "v1/cart/apply-coupon/" + coupon,

        headers: { "x-auth-token": storage.get("xAuthToken") },
      });
      onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export const getAvailableGamePlatforms = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.get({
        url: "v1/settings",
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
        },
      });

      const platforms = res?.data || {};

      onSuccess?.(platforms);
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export const LinkPurchaseRaffleTicket = ({
  body = {},
  onSuccess,
  onError,
  onEnd,
}) => {
  return async (dispatch) => {
    try {
      const res = await http.post({
        url: addticket,
        body,
        headers: { "x-auth-token": storage.get("xAuthToken") },
      });
      onSuccess(res);

      if (res.data.success === true) {
        // dispatch(getCartItems(res.data.data));
      }
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export const swapProduct = ({
  body = {},
  onSuccess,
  onError,
  onEnd,
}) => {
  return async (dispatch) => {
    try {
      const res = await http.post({
        url: swap,
        body,
        headers: { "x-auth-token": storage.get("xAuthToken") },
      });
      onSuccess(res);

      if (res.data.success === true) {
        // dispatch(getCartItems(res.data.data));
      }
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

